import type { SimulationEvent } from './types';

type DistributiveOmit<T, K extends PropertyKey> = T extends unknown ? Omit<T, K> : never;

export type EventPayload = DistributiveOmit<SimulationEvent, 'tick' | 'seq'>;

/** Collects the events of one tick with stable sequence numbers. */
export class EventSink {
  readonly events: SimulationEvent[] = [];
  constructor(readonly tick: number) {}

  emit(payload: EventPayload): void {
    this.events.push({ ...payload, tick: this.tick, seq: this.events.length } as SimulationEvent);
  }
}

export function eventId(event: Pick<SimulationEvent, 'tick' | 'seq'>): string {
  return `${event.tick}.${event.seq}`;
}
